import React, { useState, useEffect, useRef } from "react";
import { Grid, Snackbar, Alert, CircularProgress, InputAdornment, InputLabel } from "@mui/material";
// import { useBatteryConfig } from "../context/BatteryConfigContext";
import { useNavigate } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";
import { ArrowForward } from '@mui/icons-material';
import BatteryDefaultImage from "../../../assets/cellCircuit.png";
import {
  StyledBox,
  StyledTypography,
  StyledFormControl,
  StyledButton,
  StyledMenuItem,
  StyledInput,
  StyledTextField,
  StyledSelect,
  StyledTypographyBlack
} from "../styles/styles";
import SampleDataBatteryPack from "../data/SampleDataBatteryPack.csv";
import BatteryScopeC from "./BatteryScopeC";

const allowedImageTypes = ["image/jpeg", "image/png"];
const allowedCsvTypes = ["text/csv"];


const validateCSVData = (csvFile) => {
  return new Promise((resolve, reject) => {
  const Headers = `Time [s],Velocity [km/h],Elevation [m],Throttle [%],Motor Torque [Nm],Longitudinal Acceleration [m/s^2],Regenerative Braking Signal,Battery Voltage [V],Battery Current [A],Battery Temperature [蚓],max. Battery Temperature [蚓],SoC [%],displayed SoC [%],min. SoC [%],max. SoC [%),Heating Power CAN [kW],Heating Power LIN [W],Requested Heating Power [W],AirCon Power [kW],Heater Signal,Heater Voltage [V],Heater Current [A],Ambient Temperature [蚓],Coolant Temperature Heatercore [蚓],Requested Coolant Temperature [蚓],Coolant Temperature Inlet [蚓],Heat Exchanger Temperature [蚓],Cabin Temperature Sensor [蚓],Module Voltage 1 [V],Module Voltage 2 [V],Module Voltage 3 [V],Module_1_Temp,Module_2_Temp,Module_3_Temp`;
  const reader = new FileReader();
  reader.onload = (event) => {
    const text = event.target.result;
    const rows = text.split("\n");
    if(rows[0] !== Headers){
      reject(new Error("Invalid CSV file. Please upload a valid CSV file."));
    }
    if(rows.length < 2){
      reject(new Error("Invalid CSV file. Please upload a valid CSV file."));
    }
    resolve(true);
  }
    reader.readAsText(csvFile);
  });
}

const SubmitBatteryData = () => {
  const [formData, setFormData] = useState({
    batteryPics: null,
    voltage: 30,
    capacity: 10,
    capacityUnit: "Ah",
    ageYears: 0,
    ageMonths: 0,
    chemistry: "lpf",
    format: "cylindrical",
    makeModel: "Samsung 18650",
    uploadData: null,
    cellVoltage: 3.7,
    cellCapacity: 5,
  });
  const [batteryImage, setBatteryImage] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [useSampleCsv, setUseSampleCsv] = useState(true);
  // const { selectedConfig, setSelectedConfig } = useBatteryConfig();
  const navigate = useNavigate();
  const batteryPicsRef = useRef(null);
  useEffect(() => {
    if (useSampleCsv) {
      fetch(SampleDataBatteryPack)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const text = event.target.result;
            setFormData((prevData) => ({
              ...prevData,
              uploadData: new File([text], "sampleDataBatteryPack.csv", { type: "text/csv" }),
            }));
          };
          reader.readAsText(blob);
        });
    }else{
      setFormData((prevData) => ({
        ...prevData,
        uploadData: null,
      }));
    }
  }, [useSampleCsv]);

  // Set default battery image
  useEffect(() => {
    const setDefaultBatteryImage = async () => {
      try {
        const response = await fetch(BatteryDefaultImage);
        const blob = await response.blob();
        const defaultFile = new File([blob], "default-battery.png", { type: "image/png" });
        
        setFormData((prevData) => ({
          ...prevData,
          batteryPics: defaultFile,
        }));
        setBatteryImage(URL.createObjectURL(defaultFile));
      } catch (error) {
        console.error("Error setting default battery image:", error);
      }
    };

    setDefaultBatteryImage();
  }, []);

  useEffect(() => {
    if(Object.keys(errors).length > 0){
      for(const error in errors){
        if(errors[error]){
          setSnackbarMessage(errors[error]);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      }
    }
  }, [errors]);

  // useEffect(() => {
  //   if (selectedConfig) {
  //     setFormData({
  //       ...selectedConfig,
  //       batteryPics: selectedConfig.batteryPics
  //         ? URL.createObjectURL(selectedConfig.batteryPics)
  //         : null,
  //       uploadData: selectedConfig.uploadData
  //         ? URL.createObjectURL(selectedConfig.uploadData)
  //         : null,
  //     });
  //     setSubmitted(true);
  //   }
  // }, [selectedConfig]);

  const validateForm = async () => {
    const newErrors = {};
    if (formData.batteryPics && !allowedImageTypes.includes(formData.batteryPics.type)) {
      newErrors.batteryPics = "Invalid file type. Only JPG and PNG are allowed.";
    }
    if (formData.uploadData && !allowedCsvTypes.includes(formData.uploadData.type)) {
      newErrors.uploadData = "Invalid file type. Only CSV files are allowed.";
    }
    if (formData.voltage <= 0 || formData.voltage > 1000) {
      newErrors.voltage = "Voltage must be between 1 and 1000.";
    }
    if (formData.capacity <= 0 || formData.capacity > 1000) {
      newErrors.capacity = "Capacity must be between 1 and 1000.";
    }
    if (formData.ageMonths < 0 || formData.ageMonths > 11) {
      newErrors.ageMonths = "Age months must be between 0 and 11.";
    }
    if (formData.ageYears < 0) {
      newErrors.ageYears = "Age years cannot be negative.";
    }
    if (!formData.makeModel) newErrors.makeModel = "Make/Model is required.";
    if (!formData.chemistry) newErrors.chemistry = "Chemistry is required.";
    if (!formData.format) newErrors.format = "Format is required.";
    if (!formData.uploadData) newErrors.uploadData = "CSV data upload is required.";
    if (formData.uploadData) {
      await validateCSVData(formData.uploadData).then((isValid) => {
        if (!isValid) {
          newErrors.uploadData = "Invalid CSV file. Please upload a valid CSV file.";
        }
      }).catch((error) => {
        newErrors.uploadData = error.message;
      });
    }
    // Battery picture is now optional since we set a default

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUnitChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      capacityUnit: event.target.value,
    }));
  };

  const goToVisualize = () => {
    navigate("/batteryscope-c/visualize");
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      if (name === "batteryPics") {
        const file = files[0];
        if (allowedImageTypes.includes(file.type)) {
          setBatteryImage(URL.createObjectURL(file));
          setFormData((prevData) => ({
            ...prevData,
            [name]: file,
          }));
          setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Invalid file type. Only JPG and PNG are allowed.",
          }));
        }
      } else if (name === "uploadData") {
        const file = files[0];
        if (allowedCsvTypes.includes(file.type)) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const text = event.target.result;
            const rows = text.split("\n").map((row) => row.split(","));
            setCsvData(rows);
          };
          reader.readAsText(file);
          setFormData((prevData) => ({
            ...prevData,
            [name]: file,
          }));
          setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Invalid file type. Only CSV files are allowed.",
          }));
        }
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleSubmit = async () => {
    if (await validateForm()) {
      setLoading(true);
      let updatedFormData = { ...formData };
      if (formData.capacityUnit === "kWh") {
        updatedFormData.capacity = ((formData.capacity * 1000) / (formData.voltage)).toFixed(2);
        updatedFormData.capacityUnit = "Ah";
        setFormData(updatedFormData);
      }
      const formDataToSend = new FormData();
      Object.keys(updatedFormData).forEach((key) => {
        if (updatedFormData[key] instanceof File) {
          formDataToSend.append(key, updatedFormData[key]);
        } else {
          formDataToSend.append(key, updatedFormData[key]);
        }
      });
      try {
        const newConfig = { ...updatedFormData };
        // setSelectedConfig(newConfig);
        setSnackbarMessage("Data submitted successfully!");
        setSnackbarSeverity("success");
        setSubmitted(true);
      } catch (error) {
        setSnackbarMessage("Failed to submit data. Please try again.");
        setSnackbarSeverity("error");
        setSubmitted(false);
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setSnackbarOpen(true);
      }
    } else {
      setSnackbarMessage("Please fix the errors before submitting.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleRetry = () => {
    setSubmitted(false);
    handleSubmit();
  };

  const handleReset = () => {
    let csv = formData.uploadData;
    if(!useSampleCsv){
      csv = null;
    }
    setFormData({
      batteryPics: null,
      voltage: 30,
      capacity: 10,
      capacityUnit: "Ah",
      ageYears: 0,
      ageMonths: 0,
      chemistry: "lpf",
      format: "cylindrical",
      makeModel: "Samsung 18650",
      uploadData: csv,
    });
    setBatteryImage(null);
    setCsvData([]);
    setErrors({});
    setSnackbarOpen(false);
    setSubmitted(false);
    // setSelectedConfig(null);
  };

  const handleEdit = () => {
    setSubmitted(false);
    setSnackbarOpen(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    // scrollable container
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '90vh',
      overflowY: 'auto',
      padding: '20px',
      position: 'relative'
    }}>
    <BatteryScopeC />
    {/* Add a next button to navigate to the visualize page */}
    <StyledButton 
      variant="contained" 
      color="primary" 
      onClick={goToVisualize} 
      sx={{ 
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '120px', 
        height: '50px', 
        fontSize: '1.1rem', 
        fontWeight: 'bold', 
        borderRadius: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 20px rgba(0, 0, 0, 0.4)',
        },
        transition: 'all 0.3s ease'
      }}
    >
      Next
      <ArrowForward />
    </StyledButton>
    </div>
  );
};

export default SubmitBatteryData;
